import repository from '../Repository';

  const technicalEndpoint = (technicalType) => ['technical', technicalType].join("/");

  const getTechnicalList = (technicalType) => repository.private().get(`${technicalEndpoint(technicalType)}`);
  const createTechnical = (technicalType, body) => repository.private().post(`${technicalEndpoint(technicalType)}/`, body);

  export {
    getTechnicalList,
    createTechnical
  }
